<template lang="pug">
div
  vm-row(vm-w="12")
    vm-col(vm-lg=12)
      .card.score-card
        h5.filter Comisiones por mes
        vm-date-picker.filter(type="year" :placeholder="$t('strings.select_date')" @on-change="applyFilters" v-model="graphicsFilters.commissionsPerMonthYear")
        apexchart(type="bar" :options="commissionsPerMonthOptions" :series="commissionsPerMonthSeries")
  vm-row(vm-w="12")
    vm-col(vm-lg=12)
      .card.score-card
        h5.filter Comisiones por vendedor
        vm-date-picker.filter(type="month" :placeholder="$t('strings.select_date')" @on-change="applyFilters" v-model="graphicsFilters.commissionsPerSellerMonth")
        apexchart(height="350" type="bar" :options="commissionsPerSellerOptions" :series="commissionsPerSellerSeries")
  vm-row(vm-w="12")    
    vm-col(vm-lg=12)
      .card.score-card
        h5.filter Ventas por vendedor
        vm-date-picker.filter(type="month" :placeholder="$t('strings.select_date')" @on-change="applyFilters" v-model="graphicsFilters.salesPerSellerMonth")
        apexchart(height="350" type="bar" :options="salesPerSellerOptions" :series="salesPerSellerSeries")
  vm-row(vm-w="12")
    vm-col(vm-lg=12)
      .card.score-card
        h5.filter Top ventas por cliente
        vm-date-picker.filter(type="month" :placeholder="$t('strings.select_date')" @on-change="applyFilters" v-model="graphicsFilters.topSalesCustomersMonth")
        apexchart(height="350" type="bar" :options="topSalesCustomersOptions" :series="topSalesCustomersSeries")
  vm-row(vm-w="12")     
    vm-col(vm-lg=12)
      .card.score-card
        h5.filter Top ventas por producto
        vm-date-picker.filter(type="month" :placeholder="$t('strings.select_date')" @on-change="applyFilters" v-model="graphicsFilters.topSalesProductsMonth")
        apexchart(height="350" type="bar" :options="topSalesProductsOptions" :series="topSalesProductsSeries")
</template>
<script>
import ModalCommissionsNote from '@/components/modals/ModalCommissionsNote.vue'
import ModalImport from '@/components/modals/ModalImport.vue'
import { createNamespacedHelpers } from 'vuex'
import Vue from 'vue'
const { mapGetters, mapActions } = createNamespacedHelpers('CommissionsV2')

export default {
  name: 'Commissions',
  components: {
    ModalCommissionsNote,
    ModalImport
  },
  data: () => ({
    graphicsFilters: {},
    chartOptions: {
      chart: {
        id: 'vuechart-example'
      },
      xaxis: {
        categories: [],
        position: 'bottom',
        type: 'string',
        axisBorder: {
          show: true
        }              
      },
      chart: {
        height: 350,
        type: 'bar'
      },
      plotOptions: {
        bar: {
          borderRadius: 10,
          dataLabels: {
            position: 'top'
          },
          columnWidth: '45%',
          distributed: true
        }
      },
      dataLabels: {
        enabled: false,
        formatter: (val) => {
          return Vue.filter('currency')(val)
        },
        offsetY: -20,
        style: {
          fontSize: '12px',
          colors: ['#0f5377', '#026481', '#347c76', '#27a398']
        }
      },
      legend: {
        show: false
      },
      colors: ['#0f5377', '#026481', '#347c76', '#27a398'],
      yaxis: {
        axisBorder: {
          show: true
        },
        axisTicks: {
          show: true
        },
        labels: {
          show: true,
          formatter: (val) => {
            return Vue.filter('currency')(val)
          }
        }
      }           
    }
  }),
  async created () {
    await this.applyInitialFilters()
    await this.applyFilters()
  },
  computed: {
    ...mapGetters(['commissionsCatalog']),
    commissionsPerMonthSeries () {
      let series =  [{
        name: 'Comisiones por mes',
        data: this.getYArray(this.commissionsCatalog.graphics.commissionsPerMonth)
      }]
      return series
    },
    commissionsPerMonthOptions () {
      let options = JSON.parse(JSON.stringify(this.chartOptions));
      options.xaxis.categories = this.getXArray(this.commissionsCatalog.graphics.commissionsPerMonth)
      return options
    },
    commissionsPerSellerSeries () {
      let series =  [{
        name: 'Comisiones por vendedor',
        data: this.getYArray(this.commissionsCatalog.graphics.commissionsPerSeller)
      }]
      return series
    },
    commissionsPerSellerOptions () {
      let options = JSON.parse(JSON.stringify(this.chartOptions));
      options.xaxis.categories = this.getXArray(this.commissionsCatalog.graphics.commissionsPerSeller)
      return options
    },
    salesPerSellerSeries () {
      let series =  [{
        name: 'Ventas por vendedor',
        data: this.getYArray(this.commissionsCatalog.graphics.salesPerSeller)
      }]
      return series
    },
    salesPerSellerOptions () {
      let options = JSON.parse(JSON.stringify(this.chartOptions));
      options.xaxis.categories = this.getXArray(this.commissionsCatalog.graphics.salesPerSeller)
      return options
    },
    topSalesCustomersSeries () {
      let series =  [{
        name: 'Top cliente por venta',
        data: this.getYArray(this.commissionsCatalog.graphics.topSalesCustomers)
      }]
      return series
    },
    topSalesCustomersOptions () {
      let options = JSON.parse(JSON.stringify(this.chartOptions));
      options.xaxis.categories = this.getXArray(this.commissionsCatalog.graphics.topSalesCustomers)
      return options
    },
    topSalesProductsSeries () {
      let series =  [{
        name: 'Top producto por venta',
        data: this.getYArray(this.commissionsCatalog.graphics.topSalesProducts)
      }]
      return series
    },
    topSalesProductsOptions () {
      let options = JSON.parse(JSON.stringify(this.chartOptions));
      options.xaxis.categories = this.getXArray(this.commissionsCatalog.graphics.topSalesProducts)
      return options
    }            
  },
  methods: {
    ...mapActions([
      'loadCatalogV2',
      'applyGraphicsFilters'
    ]),
    applyInitialFilters() {
      let now = new Date()
      this.graphicsFilters.commissionsPerMonthYear = now
      this.graphicsFilters.commissionsPerSellerMonth = now
      this.graphicsFilters.salesPerSellerMonth = now
      this.graphicsFilters.topSalesCustomersMonth = now
      this.graphicsFilters.topSalesProductsMonth = now
    },
    applyFilters() {
      this.applyGraphicsFilters({filters: this.graphicsFilters}).then(() => {
        this.loadCatalogV2({ url: 'commissions' })
      })
    },    
    getXArray(arrays) {
      const xArray = arrays.map(item => item.x);
      return xArray
    },
    getYArray(arrays) {
      const yArray = arrays.map(item => item.y);
      return yArray
    }    


  }
}
</script>